import React, {useCallback, useEffect} from "react";
import {useTranslation} from "react-i18next";
import {usePresetsContext} from "../../../context/presetsContext";
import {useTraceRoutesToNetwork} from "../../../hooks/transitlLines/useTraceRoutesToNetwork";
import {useToastContext} from "../../../context/toastContext";
import {getFilledFieldsObjOnFormSubmit, isErrorResponse, safelyParseJson} from "../../../utils/utils";
import {TraceLineToNetworkData} from "../../../api/presetsApi/types";
import {Form, Row} from "../../../components/form/Form/Form";
import * as SelectBox from "../../../components/form/SelectBox/SelectBox";
import {LoadingComponent} from "../../../components/LoadingComponent/LoadingComponent";
import {PublicTransitLayerEntityName} from "../../../api/entities/replancity_PublicTransitLine";
import {useTypedSelector} from "../../../redux/Hooks/storeSelectors";
import {selectMapLayerIdByEntityName} from "../../../redux/selectors/selectors";
import {setSourceReloadRequired} from "../../../redux/map/map-reducer";
import {useDispatch} from "react-redux";
import {ActionDialogProps, ActionMenuProps} from "../../../components/ActionMenu/ActionMenu";


const TraceLineToNetworkFabric = ({id, loadEntitiesFn}: ActionMenuProps) => {
    const TraceLineToNetwork = ({
                                    handleCloseDialog,
                                }: ActionDialogProps) => {
        const routeEntityName = PublicTransitLayerEntityName.ROUTES;
        const sourceId = useTypedSelector((state) => selectMapLayerIdByEntityName(state, routeEntityName));
        const {selectedPresetId} = usePresetsContext();
        const {loading, loadRoadPresets, roadPresetsOptions, traceLineToNetwork} = useTraceRoutesToNetwork();
        const {addToast} = useToastContext();
        const {t} = useTranslation();
        const dispatch = useDispatch();

        useEffect(() => {
            void (async function () {
                await loadRoadPresets();
            }());
        }, []);

        const onFormSubmit = useCallback(async (event) => {
            const formDataObj = getFilledFieldsObjOnFormSubmit(event);
            formDataObj['transitLineId'] = id;
            const resp = await traceLineToNetwork(formDataObj as TraceLineToNetworkData);

            if (isErrorResponse(resp)) {
                const error = typeof resp.error === 'string' ? safelyParseJson(resp.error) : resp.error;
                addToast(`${error?.['details'] ?? t('transit-lines.trace-to-network-error')}`, 'error');
            } else {
                addToast(`${t('transit-lines.trace-routes-to-network-successful')}`, 'success');
                if (sourceId) {
                    dispatch(setSourceReloadRequired({sourceId, isReloadRequired: true}));
                }
            }
            handleCloseDialog(event);
        }, [id, sourceId, traceLineToNetwork]);

        return (
            <LoadingComponent isLoading={loading}>
                <Form
                    name="traceRoutesForm"
                    onSubmit={onFormSubmit}
                    submitBtnTitle={t('transit-lines.trace-line-to-network-btn')}
                    disabled={!selectedPresetId}
                >
                    <Row>
                        <SelectBox.Labeled
                            label={t('transit-lines.road-preset')}
                            name='roadPresetId'
                            options={roadPresetsOptions}
                        />
                    </Row>
                </Form>
            </LoadingComponent>
        )
    }

    return TraceLineToNetwork;
}

export default TraceLineToNetworkFabric;